import React from 'react';

export const CollectListContext = React.createContext<any>(null);

/** 地图视角-枚举 */
export enum MapView {
  /** 全国视角 */
  National = 1,
  /** 省份视角 */
  Province = 2,
  /** 市视角 */
  City = 3,
}
/** 地图视角-选项 */
export const mapViews = [
  { value: MapView.National, label: '全国视角' },
  { value: MapView.Province, label: '省份视角' },
  { value: MapView.City, label: '市视角' },
];
/** 地图模式-枚举 */
export enum MapMode {
  /** 门店模式 */
  Store = 1,
  /** 城市模式 */
  City = 2,
  /** 省份模式 */
  Province = 3,
}
/** 地图模式-选项 */
export const mapModes = [
  { value: MapMode.Store, label: '门店模式' },
  { value: MapMode.City, label: '城市模式' },
  { value: MapMode.Province, label: '省份模式' },
];
/** 地图视角缩放级别 */
export enum MapViewZoom {
  /** 全国视角 */
  National = 5.04, // 首次加载时，地图显示的全国维度是5.04
  /** 省视角 */
  Province = 8,
  /** 市视角 */
  City = 10,
  /** 区视角 */
  District = 20,
}


export interface MockDemo {
  a: Function;
}
/* 图层zIndex大全，非hover，非开启工具集 */
export const layerBaseZIndex = {
  cityFull: 1020, // 城市全屏卡片  marker图层
  markAddress: 1010, // 标记   marker图层
  ownBrand: 1000, // 自有品牌  marker图层
  footPrint: 500, // 踩点记录点  marker图层
  competitiveBrand: 500, // 竞品品牌  mass图层
  digital3C: 500, // 小米3C  mass图层
  point: 10, // 围栏中心点位圆圈  几何图层
};
/* 图层zIndex大全，hover */
export const layerHoverZIndex = {
  markAddress: 1101, // 标记   marker图层
  ownBrand: 1101, // 自有品牌  marker图层
  footPrint: 1101, // 踩点记录点  marker图层
  competitiveBrand: 1101, // 竞品品牌  mass图层
  digital3C: 1101, // 小米3C  mass图层
};

export const layerCardHover = 2000;

export const HarmonyBrandId = 101077526; // 鸿蒙品牌id
export const AITOBrandId = 100427784; // 问界品牌id


/* 图层zIndex大全，开启工具集 */
// 汽车商圈 PointPolygon 固定 是10，处于最底部
export const toolSpecialOpenZIndex = {
  countryLayer: 120, // 全国矩形覆盖层   几何图形，仅为了让工具集可以点击穿透，无其他意义
  markAddress: 119, // 标记   marker图层
  ownBrand: 118, // 自有品牌  marker图层
  footPrint: 117, // 踩点记录点  marker图层
  // 海量点 需要低于110，才能被工具栏相关api穿透
  competitiveBrand: 109, // 竞品品牌  mass图层
  digital3C: 109, // 小米3C  mass图层
};

export const mapFilter = 'mapFilter';
export const zoomOfClick = 17;
export enum firstLevelCategoryCodesEnum{
  'SD' = 'SD', // 商业
  'CY' = 'CY', // 汽车
  'HOME' = 'HOME', // 小米之家
  'FOOT_PRINT' = 'FOOT_PRINT', // 踩点记录
}
/** 热力图枚举 */
export enum heatMapCodesEnum {
  'HEATMAP', // 热力图
  'LIVE', // 居住人口热力
  'PERMANENT', // 常驻人口热力
  'WORK', // 工作人口热力
  'CAR', // 汽车网点热力
  'MI_CAR', // 小米汽车保有量热力
  'MI_FANS', // 米粉热力
}

/**
 * @description 根据id匹配Marker
 * @param list MarkerList
 * @param id 匹配的id
 * @returns {marker,value}
 */
export const findMarkerById = (list:any[], id:number) => {
  const res:any = { marker: null, value: null };
  list.forEach((marker) => {
    const value = marker.getExtData();
    if (value.id === id) {
      res.marker = marker;
      res.value = value;
    }
  });
  return res;
};
export enum iconEnum {
  Digital3C = 'https://staticres.linhuiba.com/xiaomi/locationpc/mi_icon_3c.png', // 3c
  Businessing = 'https://staticres.linhuiba.com/xiaomi/locationpc/mi_icon_orange.png', // 已营业
  Constructing = 'https://staticres.linhuiba.com/xiaomi/locationpc/mi_icon_gray.png', // 已决策
  BrandLogo = 'https://staticres.linhuiba.com/xiaomi/locationpc/selectionmap/brand-logo.png', // 竞品logo
  Digital3CCircle = 'https://staticres.linhuiba.com/xiaomi/locationpc/mi_icon_3c_circle_orange.png', // 3c 橙色圆点
}

export const businessRankOptions = [
  {
    label: '全部',
    value: -1,
  },
  {
    label: '前5',
    value: 5
  },
  {
    label: '前10',
    value: 10
  },
  {
    label: '前20',
    value: 20
  },
];

// 新增商圈的状态枚举
export enum newPointStatusEnum{
  NO_REVIEW=0, // 无需审核
  IN_REVIEW =1, // 待审核-审核中
  APPROVE = 2, // 审核通过
  REJECT = 9// 审核拒绝
}

// 数据给的热力，前面为范围大小(150m*150m)，后面为密度(每个间隔十几米)
export enum densityEnum {
  small= 3, // 整个城市（1km的网格）-- 目前没有该层级
  middle= 4, // 40km*20km（150米的网格）
  large=5, // 4km*2km（17米的网格）
};

export const showPolygonListKey = [
  `${firstLevelCategoryCodesEnum.CY}_rank`,
  `${firstLevelCategoryCodesEnum.CY}_name`,
  `${firstLevelCategoryCodesEnum.SD}_rank`,
  `${firstLevelCategoryCodesEnum.SD}_name`
];


/** 圈选查询数据对象 */
export interface drawSearchObjType {
  loadingObj: { // 圈选查询数据过滤，完成后会设为 true，优化抽屉空状态交互
    businessCircle: Boolean;
    carCircle: Boolean;
    carStore: Boolean;
    competitors: Boolean;
  };
  /** 商业商圈 */
  businessCircle: Array<any>;
  /** 汽车商圈 */
  carCircle: Array<any>;
  /** 门店 */
  carStore: Array<any>;
  /** 竞品门店 */
  competitors: Array<any>;
  /** 竞品门店id */
  locationBrandIds: Array<any>;
  /** 画框路径 */
  drawPath: Array<any>;
};

export function findNorthernmostCoordinate(lnglatArr: any[]) {
  if (lnglatArr?.length === 0) {
    return null;
  }
  // 初始化最北的经纬度为数组的第一个元素
  let northernmost = lnglatArr[0];
  // 遍历数组中的每个经纬度
  for (let i = 1; i < lnglatArr.length; i++) {
    // 如果当前经纬度的纬度值大于最北经纬度的纬度值
    if (lnglatArr[i][1] > northernmost[1]) {
      // 更新最北的经纬度
      northernmost = lnglatArr[i];
    }
  }
  return northernmost;
}
export const creating = 'creating';
export const collecting = 'collecting';
export const allData = 'allData';
export const rankOptions:any[] = [
  { key: creating, name: '生成中', value: creating },
  { key: collecting, name: '收藏', value: collecting },
  { key: 'rank', name: '全部', value: allData },
  { key: 'rank20', name: '前20名', value: 20 },
  { key: 'rank50', name: '前50名', value: 50 },
  { key: 'rank100', name: '前100名', value: 100 },
  { key: 'rank200', name: '前200名', value: 200 },
  { key: 'rank300', name: '前300名', value: 300 },
  { key: 'rank500', name: '前500名', value: 500 },
];
export const defaultSelectedRankOption = rankOptions[5];

export enum TabOption {
  /** 城市信息 */
  City = '1',
  /** 商圈信息 */
  Business = '2'
};
// 映射服务端返回的排序项
export enum ModelClusterSortRule {
  MarketScoreSort = 1, // 默认排序,即：市场评分排序
  IndustrySort, // 行业评分
  DistanceSort, // 距离排序
  ShoppingMallDailySort, // 商场日均客流排序
  Population500Sort, // 周边500m居住人口
  Population3000Sort, // 周边3km居住人口
}
